import styled from 'styled-components';

const Wrapper = styled.div`
    .sidebar {
  width: 240px;
  background: #f9f9f9;
  padding: 1rem;
  border-right: 1px solid #ddd;
  min-height: 100vh;
}
  
.dashboard-heading2{
    color: #6e6e6e;
    font-size: 1.68219rem;
    font-style: normal;
}
.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
 ul {
     padding-left: 0rem; 
}
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 5px;
  margin-bottom: 8px;
  border-radius: 6.999px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.3s ease;
}

.sidebar-item:hover {
  background: #e4f0ff;
}

.sidebar-item.active {
  border: 0.875px solid #e4f0ff;
  background: #0b3c5d;
  color: #fff;
  font-weight: 500;
}

.sidebar-item .icon {
  font-size: 14px;
}
.bx-shd{
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}
`;

export default Wrapper;
